module.exports = __webpack_public_path__ + "static/pelmorex-logo-cdf85c3c52c8c6a805ad29406621a64b.png";